var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOeDummyIcon = function SvgOeDummyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M5.264 8.917S3.722 6.55 5.137 5.136c1.413-1.414 3.78.128 3.78.128S9.5 2.5 11.5 2.5s2.583 2.764 2.583 2.764 2.368-1.542 3.782-.128c1.414 1.414-.128 3.781-.128 3.781S20.5 9.5 20.5 11.5s-2.763 2.583-2.763 2.583 1.542 2.367.128 3.781c-1.414 1.414-3.782-.128-3.782-.128S13.5 20.5 11.5 20.5s-2.583-2.764-2.583-2.764-2.367 1.542-3.78.128c-1.415-1.414.127-3.781.127-3.781S2.5 13.5 2.5 11.5s2.764-2.583 2.764-2.583zM15.5 9.5l-5 5-2-2",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgOeDummyIcon as ReactComponent };
export default __webpack_public_path__ + "366a76ad1e6196e26bbfe808f503354d.svg";